import { useEffect, useRef, useState } from "react";
import { CaretDown, Desktop, Moon, Sun } from "@phosphor-icons/react";
import { useTheme } from "next-themes";

const options = [
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
  { value: "system", label: "System", icon: Desktop },
];

export default function PublicThemeControl({ compact = false }) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => setMounted(true), []);

  useEffect(() => {
    const close = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, []);

  const selected = mounted ? theme || "dark" : "dark";
  const active = options.find((option) => option.value === selected) || options[1];
  const ActiveIcon = active.icon;

  return (
    <div className={`public-theme-control${compact ? " is-compact" : ""}`} ref={rootRef}>
      <button
        type="button"
        className="public-theme-control__trigger"
        onClick={() => setOpen((value) => !value)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={`Appearance: ${active.label}`}
      >
        <ActiveIcon size={16} />
        {!compact && <span>{active.label}</span>}
        <CaretDown size={13} className={open ? "is-open" : ""} />
      </button>

      {open && (
        <div className="public-theme-control__menu" role="menu" aria-label="Appearance">
          {options.map(({ value, label, icon: Icon }) => (
            <button
              key={value}
              type="button"
              role="menuitemradio"
              aria-checked={selected === value}
              className={selected === value ? "is-selected" : ""}
              onClick={() => {
                setTheme(value);
                setOpen(false);
              }}
            >
              <Icon size={16} />
              <span>{label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
